interface CurrencyDefinition {
  symbol: string;
  placement: 'prefix' | 'suffix';
}

const currencyConfig: { [key: string]: CurrencyDefinition } = {
  AUD: { symbol: '$', placement: 'prefix' },
  CAD: { symbol: '$', placement: 'prefix' },
  CHF: { symbol: 'Fr.', placement: 'suffix' },
  CNY: { symbol: '¥', placement: 'prefix' },
  CZK: { symbol: 'Kč', placement: 'suffix' },
  DKK: { symbol: 'kr', placement: 'suffix' },
  EUR: { symbol: '€', placement: 'prefix' },
  FOK: { symbol: 'kr', placement: 'suffix' },
  GBP: { symbol: '£', placement: 'prefix' },
  HKR: { symbol: 'kn', placement: 'suffix' },
  HUF: { symbol: 'Ft', placement: 'suffix' },
  ISK: { symbol: 'kr', placement: 'suffix' },
  JPY: { symbol: '¥', placement: 'prefix' },
  KRW: { symbol: '₩', placement: 'prefix' },
  NOK: { symbol: 'kr', placement: 'suffix' },
  PLN: { symbol: 'zł', placement: 'suffix' },
  RON: { symbol: 'L', placement: 'suffix' },
  RUB: { symbol: '₽', placement: 'suffix' },
  SEK: { symbol: 'kr', placement: 'suffix' },
  USD: { symbol: '$', placement: 'prefix' },
};

export function formatCurrencySymbol(price: string, code: string) {
  if (currencyConfig[code]) {
    const { symbol, placement } = currencyConfig[code];

    if (placement === 'prefix') {
      return `${symbol}\u00A0${price}`;
    }

    if (placement === 'suffix') {
      return `${price}\u00A0${symbol}`;
    }
  }

  // return no symbol for unknown currency
  return price;
}

export function formatCurrencyIsoCode(price: string, code: string, placeCurrencyBefore?: boolean) {
  return placeCurrencyBefore ? `${code}\u00A0${price}` : `${price}\u00A0${code}`;
}
